import {createSlice} from "@reduxjs/toolkit";

const initialClientsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  clientForEdit: undefined,
  lastError: null,
  client: undefined,
};
export const callTypes = {
  list: "list",
  links: "links",
  action: "action",
  match: "match",
  filters: "filters"
};

export const companiesSlice = createSlice({
  name: "companies",
  initialState: initialClientsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductById
    clientFetched: (state, action) => {
      state.actionsLoading = false;
      state.clientForEdit = action.payload.clientForEdit;
      state.error = null;
    },
    // findProducts
    clientsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log(action.payload);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createProduct
    productCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.product);
    },
    // updateProduct
    productUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.product.id) {
          return action.payload.product;
        }
        return entity;
      });
    },

    // updateProduct
    productImagesUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.productForEdit.image = action.payload.images;
    },

    // deleteProduct
    productDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteProducts
    productsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // productsUpdateState
    productsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    // findProductLinks
    productAllLinksFetched: (state, action) => {
      const { totalLinkCount, links} = action.payload;
      state.listInspectLinkLoading = false;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.linksForInspect = links;
      state.totalInspectLinkCount = totalLinkCount;
    },
    // findProductLinks
    productLinksFetched: (state, action) => {
      const { totalLinkCount, links, product, buckets, platforms, conversion} = action.payload;

      console.log(platforms);
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.links = links;
      state.buckets = buckets;
      state.platforms = platforms;
      state.product = product;
      state.conversion = conversion;
      state.totalLinkCount = totalLinkCount;
    },
    // findMacroProductLinks
    productMacroLinksFetched: (state, action) => {
      const { totalLinkCount, links, macroBuckets} = action.payload;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.links = links;
      state.macroBuckets = macroBuckets;
      state.totalLinkCount = totalLinkCount;
    },
    // findProductLinksMatched
    productLinksMatchedFetched: (state, action) => {
      const { totalLinksMatchCount } = action.payload;
      state.error = null;
      state.totalLinksMatchCount = totalLinksMatchCount;
    },
    // findProductLinkMatched (filter numbers)
    productLinkMatchFetched: (state, action) => {
      const { filter_id, totalLinksMatchCount } = action.payload;
      state.error = null;
      if (filter_id) {
        state.totalFilterMatchCount[filter_id] = totalLinksMatchCount;
      }
    },
    // getLinkById
    productLinkFetched: (state, action) => {
      state.actionsLoading = false;
      state.linkForEdit = action.payload.linkForEdit;
      state.conversion = action.payload.conversion || state.conversion;
      state.error = null;
    },
    // updateLink
    productLinkUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.links = state.links.map(link => {
        if (link.id === action.payload.link.id) {
          return action.payload.link;
        }
        return link;
      });
    },
    // findProductFilters
    productFiltersFetched: (state, action) => {
      const { productFilters } = action.payload;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.productFilters = productFilters;
    },
    // updateFilter
    filterLinesUpdated: (state, action) => {
      const { id, lines } = action.payload;

      const updatedFilter = state.product.filter.findIndex((filter) => {
        return filter.id == lines.id;
      });

      if (updatedFilter > -1) {
        state.product.filter[updatedFilter].filter_lines = lines.lines;
        state.product.filterUpdated = [];
        state.product.filterUpdated[updatedFilter] = lines;
      }
    },
  }
});

